module.exports = __webpack_public_path__ + "static/media/loader.23f8a636.gif";